module.exports = __webpack_public_path__ + "img/icon-ordini.fe26d344.svg";